export default "__VITE_ASSET__6ba7f49d__"